const specs = [
  {
    icon: 'ri-building-2-line',
    title: 'Kullanılan Malzemeler',
    items: [
      'Yüksek dayanımlı alüminyum profil kasa',
      'Temperli cam veya özel difüzör ön panel',
      'UV dayanımlı backlit film baskı',
      'Anodize yüzey kaplama seçenekleri',
    ],
  },
  {
    icon: 'ri-drop-line',
    title: 'Baskı ve Görsel Kalitesi',
    items: [
      'Endüstriyel solvent UV baskı teknolojisi',
      '720 dpi – 1440 dpi yüksek çözünürlük',
      '5 yıl solmaz garanti ile baskı',
      'CMYK + beyaz mürekkep baskı imkânı',
    ],
  },
  {
    icon: 'ri-sun-line',
    title: 'LED Aydınlatma Yapısı',
    items: [
      'Samsung / Cree marka LED strip modüller',
      '50.000+ saat LED ömrü',
      'Titreşimsiz ve göz yormayan homojen ışık',
      'IP20 (iç) veya IP65 (dış mekan) seçenekleri',
    ],
  },
  {
    icon: 'ri-ruler-2-line',
    title: 'Ölçüye Özel Üretim',
    items: [
      'Minimum sipariş: 1 adet',
      'Her boyut ve şekilde üretim imkânı',
      'Tek taraflı veya çift taraflı modeller',
      'Standart ve özel profil seçenekleri',
    ],
  },
  {
    icon: 'ri-tools-line',
    title: 'Montaj ve Bakım Kolaylığı',
    items: [
      'Kolay açılır ön panel sistemi',
      'Görsel değişimi alet gerektirmez',
      'Duvara, tavana veya ayaklığa montaj',
      'Periyodik LED bakımı 3-5 yılda bir',
    ],
  },
];

export default function TechnicalSpecs() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-red-600 text-sm font-semibold uppercase tracking-widest mb-4">
            <span className="w-8 h-0.5 bg-red-600 inline-block"></span>
            Teknik Detaylar
            <span className="w-8 h-0.5 bg-red-600 inline-block"></span>
          </div>
          <h2 className="text-4xl font-black text-gray-900 mb-4">Teknik Özellikler</h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto leading-relaxed">
            Lightbox ürünlerimizde kullanılan malzeme, baskı ve LED teknolojisi hakkında teknik bilgiler.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {specs.map((spec) => (
            <div key={spec.title} className="bg-white rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-red-100 rounded-xl">
                  <i className={`${spec.icon} text-red-600 text-lg`}></i>
                </div>
                <h3 className="font-bold text-gray-900 text-base">{spec.title}</h3>
              </div>
              <ul className="space-y-2">
                {spec.items.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-check-line text-red-500 flex-shrink-0 mt-0.5"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
